































import Vue from 'vue'
import {mapActions, mapMutations, mapState} from 'vuex'
// moment
import moment from 'moment'
import 'moment/locale/it'
// costanti per gli interventi fitosanitari
export default Vue.extend({
    computed: {
        ...mapState('mapplantsInterventiEseguiti', ['interventiEseguiti'])
    },
    methods: {
        ...mapActions('modal', ['showModal']),
        ...mapActions('mapplantsInterventiEseguiti', ['pullInterventiEseguiti']),
        ...mapMutations('mapplantsInterventiEseguiti', ['ORDER_BY_ID', 'ORDER_BY_RILEVAMENTO_ID', 'ORDER_BY_DATA_INTERVENTO', 'ORDER_BY_DATA_PROSSIMO_INTERVENTO']),
        dataInterventoParsata(intervento): string {
            // leggiamo la data
            moment.locale('it')
            return moment(intervento.data_intervento).format('DD MMMM YYYY')
        },
        dataProssimoInterventoParsata(intervento): string {
            if (intervento.data_prossimo_intervento) {
                // leggiamo la data
                moment.locale('it')
                return moment(intervento.data_prossimo_intervento).format('DD MMMM YYYY')
            } else {
                return 'Nessuna data pianificata'
            }
        }
    },
    mounted() {
        // carichiamo gli interventi eseguiti
        this.pullInterventiEseguiti()
    }
})
